module.exports = __webpack_public_path__ + "img/present.e613b735.jpeg";